import { IMenuByTypesItem } from '@r1-frontend/api-domru/api-content/v2/menu/by-types';

export interface ICommonHeaderBaseProps {
    items: Record<string, IMenuByTypesItem[]>,
    hasPhoneInfo?: boolean,
}

export interface IUnauthHeaderProps extends ICommonHeaderBaseProps {
    onBecomeClientHandler: () => void,
    referrerPath: string,
}

export const breakpoints = {
    desktop: '1599px',
    sDesktop: '1365px',
    tablet: '1121px',
    mobile: '768px',
    mMobile: '650px',
    sMobile: '350px',
};
